import { forwardRef, useCallback } from 'react';
import { Input } from '@library/components/inputs';
import type { InputProps } from '@library/components/inputs';
import type { Ref } from 'react';
import { cn } from '@library/component-utils/cn';
import { formatPhoneNumber } from '@library/component-utils/input';

export interface PhoneNumberInputProps extends InputProps {
  className?: string;
  id: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  showSearchIcon?: boolean;
  value: string;
}

const CustomPhoneNumberInput = (
  {
    className = '',
    id,
    onValueChange,
    placeholder = '+1 (555) 555-5555',
    value,
    ...rest
  }: PhoneNumberInputProps,
  ref: Ref<HTMLInputElement>
) => {
  const handleOnValueChange = useCallback(
    (newValue: string) => {
      const formattedValue = formatPhoneNumber(newValue);
      onValueChange(formattedValue);
    },
    [onValueChange]
  );

  return (
    <Input
      className={cn(
        'text-soClean-100 placeholder:text-soClean-180 border-soFresh-140 bg-soFresh-110 w-full rounded-md border text-sm hover:ring-0 focus:ring-0 sm:leading-6',
        className
      )}
      type="tel"
      id={id}
      placeholder={placeholder}
      maxLength={17}
      onValueChange={handleOnValueChange}
      ref={ref}
      value={value}
      {...rest}
    />
  );
};

export const PhoneNumberInput = forwardRef(CustomPhoneNumberInput);
